export enum ILiveWithMySpouse {
    'At or Below $1,452',
    '$1,453 - $1,815',
    '$1,816 - $2,178',
    '$2,179 - $2,540',
    '$2,541 - $2,903',
    '$2,904 or over',
    Other,
}
